// extracted by mini-css-extract-plugin
export default {"btn":"counter-button_btn__k5u4G"};